const ITEMS = [
  "Hydroseeding",
  "Site Preparation",
  "Utility Trenching",
  "Land Clearing",
  "Final Grading",
  "Erosion Control",
  "Call 423-748-2012",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span
        key={item + (hidden ? "-b" : "-a")}
        className="flex items-center font-mono text-sm font-semibold uppercase tracking-[0.3em] text-[#e9dfc8]/75"
      >
        <span className="px-6">{item}</span>
        <span className="text-[#9fd8b4]/40">•</span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="services-marquee"
      className="marquee-pause overflow-hidden border-y border-[#122e21] bg-[#16382a] py-5"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
